export const initialStepsData: any[] = [
  {
    id: 1,
    title: "Improve Market Share Goal: $15M → $17M",
    date: "07.01.2024",
    stepsCount: 3,
    status: "new",
    subtasks: [
      {
        id: 101,
        title: "Optimize Content",
        description:
          "Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla, mattis ligula consectetur, ultrices mauris.",
        completed: false,
      },
      {
        id: 102,
        title: "Setup Ad Spend Goal + ACOS goal",
        description:
          "Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi. Aliquam in hendrerit urna. Pellentesque sit amet sapien fringilla.",
        completed: false,
      },
      {
        id: 103,
        title: "Add new product",
        description:
          "Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et massa mi.",
        completed: false,
      },
    ],
  },
  {
    id: 2,
    title: "Improve ACOS by adjusting Ad Spend",
    date: "29.12.2023",
    stepsCount: 3,
    status: "done",
    subtasks: [
      {
        id: 201,
        title: "Analyze current spend",
        description: "Lorem ipsum dolor sit amet...",
        completed: true,
      },
      {
        id: 202,
        title: "Adjust bids accordingly",
        description: "Ut tristique fringilla sapien...",
        completed: true,
      },
      {
        id: 203,
        title: "Review performance metrics",
        description: "Nulla facilisi...",
        completed: true,
      },
    ],
  },
  {
    id: 3,
    title: "Add keywords to the keyword tracker",
    date: "28.12.2023",
    stepsCount: 1,
    status: "done",
    subtasks: [
      {
        id: 301,
        title: "Research new keywords",
        description: "Etiam et aliquam risus...",
        completed: true,
      },
    ],
  },
  {
    id: 4,
    title: "Asin B073RMM2P amount:150 pieces should be shipped",
    date: "28.12.2023",
    stepsCount: 2,
    status: "done",
    subtasks: [
      {
        id: 401,
        title: "Check warehouse stock",
        description: "Vivamus tristique massa a lorem dignissim pretium.",
        completed: true,
      },
      {
        id: 402,
        title: "Coordinate shipping with logistics",
        description: "Maecenas a metus eu libero varius imperdiet.",
        completed: true,
      },
    ],
  },
  {
    id: 5,
    title: "Improve conversion by creating A+ Content",
    date: "27.12.2023",
    stepsCount: 2,
    status: "done",
    subtasks: [
      {
        id: 501,
        title: "Draft A+ content layout",
        description: "Sed ut perspiciatis unde omnis iste natus error.",
        completed: true,
      },
      {
        id: 502,
        title: "Apply brand styling",
        description: "Accusantium doloremque laudantium, totam rem aperiam.",
        completed: true,
      },
    ],
  },
  {
    id: 6,
    title: "Improve Product Listing optimization",
    date: "26.12.2023",
    stepsCount: 2,
    status: "done",
    subtasks: [
      {
        id: 601,
        title: "Update listing titles",
        description: "Quisque pulvinar arcu non risus finibus tincidunt.",
        completed: true,
      },
      {
        id: 602,
        title: "Enhance bullet points and images",
        description: "Phasellus semper, tellus eget ultricies auctor.",
        completed: true,
      },
    ],
  },
];
